import styled from 'styled-components';

import { DoubleColumnBanner } from '../../styled/components/double-column-banner';

export const RiskAssessmentBanner = styled(DoubleColumnBanner)`
  .banner-container {
    padding-bottom: 45px;
  }

  .banner-header-xl {
    margin-top: 20px;
    line-height: 3rem;
  }

  .banner-header-sm {
    line-height: 2rem;
  }

  .column-margin {
    margin-right: 55px;
  }
  
  .header-second-col {
    .checkmark-text {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .checkmark {
      max-width: 25px;
      padding-top: 5px;
    }

    .white-panel-subtext {
      margin: 10px 32px;
    }
  }
`;
